import { Component, Input, ViewChild, TemplateRef } from "@angular/core";
import { Address } from "@models";
import { CryptoQRComponent } from "../crypto-qr/crypto-qr.component";
import { ModalService } from "@core-services/modal.service";
import { BpModalFrameComponent } from "../../../core/components/bp-modal-frame/bp-modal-frame.component";

@Component({
	selector: "crypto-wallet-address",
	templateUrl: "./crypto-wallet-address.component.html",
	styleUrls: ["./crypto-wallet-address.component.scss"],
	standalone: false
})
export class CryptoWalletAddressComponent {
	public constructor(private modalService: ModalService) {}

	@Input()
	public address: Address;
	@Input()
	public coinSymbol: string = "";

	@ViewChild("qrTemplate", { read: TemplateRef, static: true })
	public qrTemplate: TemplateRef<CryptoQRComponent>;
	public openQr(): void {
		this.modalService
			.create(BpModalFrameComponent, {
				templateRef: this.qrTemplate,
				showCloseButton: true,
				noPadding: false,
				title: "Your current wallet Address",
				subheader: "You can scan this address to easily copy your wallet address."
			})
			.present();
	}

	public closeModal(): void {
		this.modalService.pop();
	}
}
